import claims from './lib/configs/claims.json';

export * from './lib/configurations.module';
export * from './lib/tokens';
export * from './lib/districts';

export const RAW_CLAIMS = claims as [string, string, number][];
